const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

function action(type, payload = {}) {
  return { type, ...payload };
}

export const NO_CARD_ERROR = 453;
export const DUPLICATE_JOB_ERROR = 454;

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const showMessage = (payload) => action(SHOW_MESSAGE, { payload });

export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const hideMessage = () => action(HIDE_MESSAGE);

export const SHOW_REGISTRATION_SUCCESS_POPUP = 'SHOW_REGISTRATION_SUCCESS_POPUP';
export const showRegistrationPopup = () => action(SHOW_REGISTRATION_SUCCESS_POPUP);

export const HIDE_REGISTRATION_SUCCESS_POPUP = 'HIDE_REGISTRATION_SUCCESS_POPUP';
export const hideRegistrationPopup = () => action(HIDE_REGISTRATION_SUCCESS_POPUP);

export const SHOW_JOB_CREATE_PAYMENT_ERROR = 'SHOW_JOB_CREATE_PAYMENT_ERROR';
export const showJobCreatePaymentError = () => action(SHOW_JOB_CREATE_PAYMENT_ERROR);

export const HIDE_JOB_CREATE_PAYMENT_ERROR = 'HIDE_JOB_CREATE_PAYMENT_ERROR';
export const hideJobCreatePaymentError = () => action(HIDE_JOB_CREATE_PAYMENT_ERROR);

export const FETCH_AVERAGE_RATING = 'FETCH_AVERAGE_RATING';
export const fetchAverageRating = () => action(FETCH_AVERAGE_RATING);

export const INITIAL_LOADING = 'INITIAL_LOADING';
export const initialLoading = () => action(INITIAL_LOADING);

export const SIGN_IN_ACTION = 'SIGN_IN_ACTION';
export const signIn = (cred) => action(SIGN_IN_ACTION, cred);

export const SIGN_UP_ACTION = 'SIGN_UP_ACTION';
export const signUp = (cred) => action(SIGN_UP_ACTION, cred);

export const FORGOT_PASSWORD_SEND_CODE_ACTION = 'FORGOT_PASSWORD_SEND_CODE_ACTION';
export const forgotPasswordSendCode = (cred) => action(FORGOT_PASSWORD_SEND_CODE_ACTION, cred);

export const FORGOT_PASSWORD_RESET_ACTION = 'FORGOT_PASSWORD_RESET_ACTION';
export const forgotPasswordReset = (cred) => action(FORGOT_PASSWORD_RESET_ACTION, cred);

export const HIDE_FORGOT_PASSWORD_ERROR_MODAL = 'HIDE_FORGOT_PASSWORD_ERROR_MODAL';

export const CLEAR_FORGOT_PASSWORD_STATE = 'CLEAR_FORGOT_PASSWORD_STATE';
export const clearForgotPasswordState = () => action(CLEAR_FORGOT_PASSWORD_STATE);

export const EDIT_GENERAL_INFO_ACTION = 'EDIT_GENERAL_INFO_ACTION';
export const editUserGeneral = (data) => action(EDIT_GENERAL_INFO_ACTION, data);

export const EDIT_USER_OFFICE_INFO = 'EDIT_USER_OFFICE_INFO';
export const editUserOfficeInfo = (data) => action(EDIT_USER_OFFICE_INFO, data);

export const EDIT_USER = 'EDIT_USER';
export const editUser = (data) => action(EDIT_USER, data);

export const BLOCK_PROFESSIONAL = 'BLOCK_PROFESSIONAL';
export const blockProfessional = (data) => action(BLOCK_PROFESSIONAL, data);

export const IS_OVERLAPPING_JOB = 'IS_OVERLAPPING_JOB';
export const isOverlapingJob = (data) => action(IS_OVERLAPPING_JOB, data);

export const EDIT_ACCOUNT_INFO_ACTION = 'EDIT_ACCOUNT_INFO_ACTION';
export const editUserAccount = (data) => action(EDIT_ACCOUNT_INFO_ACTION, data);

export const LOGOUT_ACTION = 'LOGOUT_ACTION';
export const logOut = (payload) => action(LOGOUT_ACTION, payload);

// The NPS answer itself is a React Query mutation (domain/NpsReview). These two
// are what it tells Redux: the user reducer clears `show_nps` on the first; the
// second carries the `_FAILURE` suffix the error reducer keys on, so the server's
// message reaches the global error popup.
export const NPS_REVIEW_SUBMITTED = 'NPS_REVIEW_SUBMITTED';
export const npsReviewSubmitted = () => action(NPS_REVIEW_SUBMITTED);
export const NPS_REVIEW_SUBMIT_FAILURE = 'NPS_REVIEW_SUBMIT_FAILURE';
// Built by hand: `action()` spreads its payload, and the error reducer reads `action.payload`.
export const npsReviewSubmitFailed = (payload) => ({ type: NPS_REVIEW_SUBMIT_FAILURE, payload });

export const UPDATE_RATING_COUNT = 'UPDATE_RATING_COUNT';

export const CLOSE_MODAL_ACTION = 'CLOSE_MODAL_ACTION';
export const closeModal = () => action(CLOSE_MODAL_ACTION);

export const PHONE_VERIFICATION_ACTION = 'PHONE_VERIFICATION_ACTION';
export const phoneVerification = (code) => action(PHONE_VERIFICATION_ACTION, code);

export const GET_ALL_PROFESSIONS_ACTION = 'GET_ALL_PROFESSIONS_ACTION';

export const GET_ALL_SPECIALIZATIONS_ACTION = 'GET_ALL_SPECIALIZATIONS_ACTION';

export const GET_USER_EDUCATION_ACTION = 'GET_USER_EDUCATION_ACTION';
export const getUserEducation = (data) => action(GET_USER_EDUCATION_ACTION, data);

export const GET_OFFICE_EDUCATION_ACTION = 'GET_OFFICE_EDUCATION_ACTION';
export const getOfficeEducation = (data) => action(GET_OFFICE_EDUCATION_ACTION, data);

export const UPDATE_USER_EDUCATION_ACTION = 'UPDATE_USER_EDUCATION_ACTION';

export const UPLOAD_AVATAR_ACTION = 'UPLOAD_AVATAR_ACTION';
/** `{ avatar, officeId? }` — `officeId` uploads to that location instead of the selected office. */
export const uploadAvatar = (data) => action(UPLOAD_AVATAR_ACTION, data);

export const GET_ALL_SOFTWARES_ACTION = 'GET_ALL_SOFTWARES_ACTION';
export const getAllSoftwares = () => action(GET_ALL_SOFTWARES_ACTION);

export const ACCEPT_TERMS_ACTION = 'ACCEPT_TERMS_ACTION';

export const ACCEPT_PSA_TERMS_ACTION = 'ACCEPT_PSA_TERMS_ACTION';

// dso

export const SELECT_OFFICE = 'SELECT_OFFICE';
export const selectOffice = (officeId) => action(SELECT_OFFICE, officeId);

export const SEARCH_OFFICE_ACTION = 'SEARCH_OFFICE_ACTION';
export const searchChildOffice = (searchText) => action(SEARCH_OFFICE_ACTION, searchText);

// feedback

export const FEEDBACK_REQUIRED = 'FEEDBACK_REQUIRED';
export const feedbackRequire = () => action(FEEDBACK_REQUIRED);

export const FETCH_USER_PROCEDURE_ENDORSEMENT = 'FETCH_USER_PROCEDURE_ENDORSEMENT';

// pp
export const FETCH_ALL_PP_JOBS = 'FETCH_ALL_PP_JOBS';

export const FETCH_APPLICATIONS_PP = 'FETCH_APPLICATIONS_PP';
export const fetchPPapplications = (jobId) => action(FETCH_APPLICATIONS_PP, jobId);

export const FETCH_APPLICATION_BY_ID_PP = 'FETCH_APPLICATION_BY_ID_PP';
export const fetchPPapplicationById = (jobId, applicationId) =>
  action(FETCH_APPLICATION_BY_ID_PP, jobId, applicationId);

export const POST_ACTION_PP = 'POST_ACTION_PP';
export const postPPAction = (jobId, applicationId, actionType, notes) =>
  action(POST_ACTION_PP, jobId, applicationId, actionType, notes);

export const CHANGE_SCHEDULE = 'CHANGE_SCHEDULE';
export const changeSchedule = (payload) => action(CHANGE_SCHEDULE, payload);

export const FETCH_JOB_ACTION = 'FETCH_JOB_ACTION';
export const fetchJob = (jobId) => action(FETCH_JOB_ACTION, jobId);

export const SELECT_JOB_ACTION = 'SELECT_JOB_ACTION';

export const GET_ALL_JOBS_ACTION = 'GET_ALL_JOBS_ACTION';
export const getAllJobs = (data) => action(GET_ALL_JOBS_ACTION, data);

export const GET_JOBS_BY_STATUS_DATE_ACTION = 'GET_JOBS_BY_STATUS_DATE_ACTION';
export const getJobsByStatusOrDate = (status, date) =>
  action(GET_JOBS_BY_STATUS_DATE_ACTION, { status, date });

// Optimistically drop a job from the schedule list (state.job.jobList) — e.g. after a
// cancel, whose React Query invalidation doesn't reach this Redux-backed list.
export const REMOVE_JOB_FROM_SCHEDULE_LIST = 'REMOVE_JOB_FROM_SCHEDULE_LIST';
// Built with an explicit `payload` (not the spread `action()` helper) so the reducer can
// read `action.payload.jobId`, matching the IAction<T, P> contract.
export const removeJobFromScheduleList = (jobId) => ({
  type: REMOVE_JOB_FROM_SCHEDULE_LIST,
  payload: { jobId },
});

export const FETCH_JOBS_WITH_TRANSACTIONS = 'FETCH_JOBS_WITH_TRANSACTIONS';
export const fetchJobsWithTransactions = (data) => action(FETCH_JOBS_WITH_TRANSACTIONS, data);

export const UPDATE_JOB_ACTION = 'UPDATE_JOB_ACTION';

export const FETCH_OPEN_JOBS_ACTION = 'FETCH_OPEN_JOBS_ACTION';
export const fetchOpenJobs = (jobData) => action(FETCH_OPEN_JOBS_ACTION, jobData);

export const FETCH_SCHEDULED_JOBS_ACTION = 'FETCH_SCHEDULED_JOBS_ACTION';
export const fetchScheduledJobs = (jobData) => action(FETCH_SCHEDULED_JOBS_ACTION, jobData);

export const FETCH_ACTION_REQUIRED_JOBS_ACTION = 'FETCH_ACTION_REQUIRED_JOBS_ACTION';
export const fetchActionRequiredJobs = (jobData) =>
  action(FETCH_ACTION_REQUIRED_JOBS_ACTION, jobData);

export const FETCH_TODAY_JOBS_ACTION = 'FETCH_TODAY_JOBS_ACTION';
export const fetchTodayJobs = (jobData) => action(FETCH_TODAY_JOBS_ACTION, jobData);

export const CLOSE_OVERLAPPING_MODAL = 'CLOSE_OVERLAPPING_MODAL';
export const closeOverlappingModal = (data) => action(CLOSE_OVERLAPPING_MODAL, data);

export const FETCH_EXPIRED_COUNTER_OFFERS = 'FETCH_EXPIRED_COUNTER_OFFERS';
export const fetchExpiredCounterOffers = (jobId) => action(FETCH_EXPIRED_COUNTER_OFFERS, jobId);

export const FETCH_RECEIPTS_REPORT = 'FETCH_RECEIPTS_REPORT';

export const CLEAR_RECEIPTS_REPORT = 'CLEAR_RECEIPTS_REPORT';

export const FETCH_RECEIPTS_CSV_REPORT_V2 = 'FETCH_RECEIPTS_CSV_REPORT_V2';
export const fetchReceiptsCSVReportV2 = (payload) =>
  action(FETCH_RECEIPTS_CSV_REPORT_V2, { payload });

export const CLEAR_RECEIPTS_CSV_REPORT_V2 = 'CLEAR_RECEIPTS_CSV_REPORT_V2';
export const clearReceiptsCSVReportV2 = () => action(CLEAR_RECEIPTS_CSV_REPORT_V2);

export const CLEAR_ALL_RECEIPTS = 'CLEAR_ALL_RECEIPTS';
export const clearAllReceipts = () => action(CLEAR_ALL_RECEIPTS);

export const FETCH_INVOICE_LIST = 'FETCH_INVOICE_LIST';
export const fetchInvoiceList = (state) => action(FETCH_INVOICE_LIST, { state });

// multiday
export const SHOW_JOBS_INVITE_CONFIRMATION_POPUP = 'SHOW_JOBS_INVITE_CONFIRMATION_POPUP';

export const SHOW_JOBS_INVITE_SELECTION_POPUP = 'SHOW_JOBS_INVITE_SELECTION_POPUP';
export const showJobInvitesSelectionPop = () => action(SHOW_JOBS_INVITE_SELECTION_POPUP);

export const HIDE_JOBS_INVITE_POPUP = 'HIDE_JOBS_INVITE_POPUP';
export const hideJobsInvitePopup = () => action(HIDE_JOBS_INVITE_POPUP);

export const SHOW_EOD_INVITE_POPUP = 'SHOW_EOD_INVITE_POPUP';
export const showEodInvitePopup = () => action(SHOW_EOD_INVITE_POPUP);

export const HIDE_EOD_INVITE_POPUP = 'HIDE_EOD_INVITE_POPUP';
export const hideEodInvitePopup = () => action(HIDE_EOD_INVITE_POPUP);

export const SHOW_CHILD_MISSING_TERMS_POPUP = 'SHOW_CHILD_MISSING_TERMS_POPUP';

export const HIDE_CHILD_MISSING_TERMS_POPUP = 'HIDE_CHILD_MISSING_TERMS_POPUP';
export const closeChildMissingTermsPopup = () => action(HIDE_CHILD_MISSING_TERMS_POPUP);

// receipts

export const FETCH_RECEIPT_LIST = 'FETCH_RECEIPT_LIST';
export const fetchReceiptList = (state) => action(FETCH_RECEIPT_LIST, { state });

export const FETCH_RECEIPTS_V2 = 'FETCH_RECEIPTS_V2';
export const fetchReceiptsV2 = (payload) => action(FETCH_RECEIPTS_V2, { payload });

export const UPDATE_RECEIPT_DISPLAY_MODE = 'UPDATE_RECEIPT_DISPLAY_MODE';
export const updateReceiptDisplayMode = (payload) =>
  action(UPDATE_RECEIPT_DISPLAY_MODE, { payload });

// adjustments

export const FETCH_JOBS_WITH_ADJUSTMENTS = 'FETCH_JOBS_WITH_ADJUSTMENTS';
export const fetchJobsWithAdjustmts = () => action(FETCH_JOBS_WITH_ADJUSTMENTS);

export const CHANGE_STATUS_ADJUSTMENT = 'CHANGE_STATUS_ADJUSTMENT';
export const changeStatusOfAdjustments = (jobId, adjustmentId, status, disputeReason) =>
  action(CHANGE_STATUS_ADJUSTMENT, jobId, adjustmentId, status, disputeReason);

// notifications

export const FETCH_NOTIFICATION_SETTINGS = 'FETCH_NOTIFICATION_SETTINGS';
/**
 * `mainAccount: true` reads the signed-in (main) account's settings whatever
 * office is selected — My profile's Notifications are the person's, not a
 * location's (GOTU-15553).
 */
export const fetchNotificationSettings = ({ mainAccount = false } = {}) =>
  action(FETCH_NOTIFICATION_SETTINGS, { mainAccount });

export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS';
export const updateNotificationSettings = (payload) =>
  action(UPDATE_NOTIFICATION_SETTINGS, payload);

// favorites professionals list
export const FETCH_FAVORITE_PROFESSIONALS = 'FETCH_FAVORITE_PROFESSIONALS';
export const fetchFavoriteProfessionals = (jobId) =>
  action(FETCH_FAVORITE_PROFESSIONALS, { jobId });

export const REMOVE_FAVORITE_PROFESSIONAL = 'REMOVE_FAVORITE_PROFESSIONAL';
export const removeFavoriteProfessional = (userId) => action(REMOVE_FAVORITE_PROFESSIONAL, userId);

export const ADD_FAVORITE_PROFESSIONAL = 'ADD_FAVORITE_PROFESSIONAL';
export const addFavoriteProfessional = (userId) => action(ADD_FAVORITE_PROFESSIONAL, { userId });

export const INVITE_FAVORITE_TO_JOB = 'INVITE_FAVORITE_TO_JOB';

// Recent Professionals
export const FETCH_RECENT_PROFESSIONALS = 'FETCH_RECENT_PROFESSIONALS';
export const fetchRecentProfessionals = (params) => action(FETCH_RECENT_PROFESSIONALS, params);

export const BLOCK_RECENT_PROFESSIONAL = 'BLOCK_RECENT_PROFESSIONAL';
export const blockRecentProfessional = (data) => action(BLOCK_RECENT_PROFESSIONAL, data);

export const FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION =
  'FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION';
export const fetchOpenJobsForRecentProfessional = (data) =>
  action(FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION, { payload: data });

// Recommended Professionals
export const FETCH_RECOMMENDED_PROFESSIONALS_ACTION = 'FETCH_RECOMMENDED_PROFESSIONALS_ACTION';
export const fetchRecommendedProfessionals = (params = {}) =>
  action(FETCH_RECOMMENDED_PROFESSIONALS_ACTION, { payload: params });

// Invites
export const FETCH_OFFICE_JOB_INVITES_ACTION = 'FETCH_OFFICE_JOB_INVITES_ACTION';
export const fetchOfficeJobInvites = (params) =>
  action(FETCH_OFFICE_JOB_INVITES_ACTION, { payload: params });

// partnership code

export const FETCH_PARTNERSHIP_ORGANIZATIONS = 'FETCH_PARTNERSHIP_ORGANIZATIONS';
export const fetchPartnershipOrganizations = () => action(FETCH_PARTNERSHIP_ORGANIZATIONS);

export const VERIFY_PARTNERSHIP_CODE = 'VERIFY_PARTNERSHIP_CODE';
export const verifyPartnershipCode = (data) => action(VERIFY_PARTNERSHIP_CODE, data);

export const HIDE_PARTNERSHIP_CODE_SUCCESS_POPUP = 'HIDE_PARTNERSHIP_CODE_SUCCESS_POPUP';
export const hidePartnershipCodeSuccessPopup = () => action(HIDE_PARTNERSHIP_CODE_SUCCESS_POPUP);

// worker type
export const SAVE_WORKER_CLASSIFICATION = 'SAVE_WORKER_CLASSIFICATION';
export const saveWorkerClassification = (payload) =>
  action(SAVE_WORKER_CLASSIFICATION, { payload });

export const GET_STATE_WORKER_CLASSIFICATION = 'GET_STATE_WORKER_CLASSIFICATION';
export const getStateWorkerClassification = () => action(GET_STATE_WORKER_CLASSIFICATION);

export const GET_WORKER_CLASSIFICATION_MANAGEMENT = 'GET_WORKER_CLASSIFICATION_MANAGEMENT';
export const getWorkerClassificationManagement = () => action(GET_WORKER_CLASSIFICATION_MANAGEMENT);

export const SAVE_CHILD_WORKER_CLASSIFICATION = 'SAVE_CHILD_WORKER_CLASSIFICATION';
export const saveChildOfficeWorkerClassification = (data) =>
  action(SAVE_CHILD_WORKER_CLASSIFICATION, data);

export const SAVE_STATUS_CHILD_WORKER_CLASSIFICATION = 'SAVE_STATUS_CHILD_WORKER_CLASSIFICATION';
export const saveStatusChildOfficeWorkerClassification = (data) =>
  action(SAVE_STATUS_CHILD_WORKER_CLASSIFICATION, data);

// A worker type saved for a location other than the selected office (GOTU-19472):
// raises the same popup as SAVE_WORKER_CLASSIFICATION without touching `user`.
export const SHOW_SUCCESS_WORKER_CLASSIFICATION_POPUP = 'SHOW_SUCCESS_WORKER_CLASSIFICATION_POPUP';
export const showSuccessWorkerClassificationPopup = (status) =>
  action(SHOW_SUCCESS_WORKER_CLASSIFICATION_POPUP, { payload: status });

export const HIDE_SUCCESS_WORKER_CLASSIFICATION_POPUP = 'HIDE_SUCCESS_WORKER_CLASSIFICATION_POPUP';
export const hideSuccessWorkerClassificationPopup = () =>
  action(HIDE_SUCCESS_WORKER_CLASSIFICATION_POPUP);

export const SHOW_CONNECTIONS_HUB_POPUP = 'SHOW_CONNECTIONS_HUB_POPUP';
export const showConnectionsHubPopup = () => action(SHOW_CONNECTIONS_HUB_POPUP);

export const HIDE_CONNECTIONS_HUB_POPUP = 'HIDE_CONNECTIONS_HUB_POPUP';
export const hideConnectionsHubPopup = () => action(HIDE_CONNECTIONS_HUB_POPUP);

export const CHANGE_HUB_FILTER = 'CHANGE_HUB_FILTER';
export const changeHubFilter = (filter) => action('CHANGE_HUB_FILTER', { payload: filter });

export const CLEAR_MULTIDAY_FORM = 'CLEAR_MULTIDAY_FORM';
export const clearMultidayForm = () => action(CLEAR_MULTIDAY_FORM);

export const GET_OFFICE_REVIEW_INFO = 'GET_OFFICE_REVIEW_INFO';

export const SHOW_REPORT_INCIDENT_POPUP = 'SHOW_REPORT_INCIDENT_POPUP';
export const showReportIncidentPopup = (payload) => action(SHOW_REPORT_INCIDENT_POPUP, { payload });

export const CANCEL_CONFIRM_REPORT_INCIDENT_POPUP = 'CANCEL_CONFIRM_REPORT_INCIDENT_POPUP';

export const SHOW_CONFIRM_REPORT_INCIDENT_POPUP = 'SHOW_CONFIRM_REPORT_INCIDENT_POPUP';
export const showConfirmReportIncidentPopup = ({ incidentType }) =>
  action(SHOW_CONFIRM_REPORT_INCIDENT_POPUP, { payload: { incidentType } });

export const SHOW_INCIDENT_REPORTED_POPUP = 'SHOW_INCIDENT_REPORTED_POPUP';

export const RESET_INCIDENT = 'RESET_INCIDENT';
export const resetIncident = () => action(RESET_INCIDENT);

export const CLEAR_INCIDENT_POPUPS = 'CLEAR_INCIDENT_POPUPS';
export const clearIncidentPopups = () => action(CLEAR_INCIDENT_POPUPS);

export const REQUEST_REPORT_ACTION = 'REQUEST_REPORT_ACTION';
export const requestReport = (payload) => action(REQUEST_REPORT_ACTION, payload);

export const FETCH_PROFESSIONAL_PROFILE = 'FETCH_PROFESSIONAL_PROFILE';
export const fetchProfessionalProfile = (
  userId,
  officeId,
  jobProfession,
  jobSubProfession,
  jobState,
) =>
  action(FETCH_PROFESSIONAL_PROFILE, {
    userId,
    officeId,
    jobProfession,
    jobSubProfession,
    jobState,
  });

export const CLEAR_SELECTED_JOB = 'CLEAR_SELECTED_JOB';
export const clearSelectedJob = () => action(CLEAR_SELECTED_JOB);
